import { EnvironmentProviders } from '@angular/core';
import { provideHighcharts } from 'highcharts-angular';

// Control-point ratio for approximating a circle with four cubic beziers.
const BEZIER_CIRCLE_RATIO = 0.5522847498307936;

function legacyCircle(x: number, y: number, w: number, h: number) {
  const cx = x + w / 2;
  const cy = y + h / 2;
  const r = Math.min(w, h) / 2;
  const c = r * BEZIER_CIRCLE_RATIO;
  return [
    ['M', cx, cy - r],
    ['C', cx + c, cy - r, cx + r, cy - c, cx + r, cy],
    ['C', cx + r, cy + c, cx + c, cy + r, cx, cy + r],
    ['C', cx - c, cy + r, cx - r, cy + c, cx - r, cy],
    ['C', cx - r, cy - c, cx - c, cy - r, cx, cy - r],
    ['Z'],
  ];
}

export function provideClassviewHighcharts(): EnvironmentProviders {
  return provideHighcharts({
    instance: async () => {
      const Highcharts = (await import('highcharts/esm/highcharts')).default;
      // Highcharts exposes symbols through an index signature.
      // eslint-disable-next-line dot-notation
      Highcharts.SVGRenderer.prototype.symbols['legacyCircle'] = legacyCircle;
      return Highcharts;
    },
    modules: () => [import('highcharts/esm/modules/accessibility')],
  });
}
